import { mapObject, mapPage } from "@/core/mapping";

function mapBrandItem() {
    return {
        id: "id",
        name: "name",
        slug: "slug",
        logo: "logo",
        picture: "picture",
        description: "description",
        detailDescription: "detailDescription",
    };
}

export function mapBrand(brand) {
    return mapObject(brand, {
        ...mapBrandItem(),
    });
}

export function mapBrands(brands) {
    return mapPage(brands, {
        ...mapBrandItem(),
    });
}
